<html>
    <body >
        <div class="page container-fluid">
          <div class="row mb-3">
            <button  routerLink="/create-company"  class="btn btn-secondary shadow-none" > <i class="fa fa-plus mr-2" aria-hidden="true"></i>Create</button>
            <input type="text" (change)="findCompany()" [(ngModel)]="tmp" style="font-family: Open Sans,Helvetica,Arial,sans-serif,FontAwesome;" class="form-control text-input col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12  mt-2" placeholder="&#xf002; Search By Company" >
          </div>
          <div class="row">
            <div class="tableResponsive table-responsive-sm table-responsive-xl table-responsive-lg table-responsive-md  mat-elevation-z1">
              <table class="sortable table table-hover tableTitle text-center">
                <thead>
                    <tr class="tableTitle ">
                      <th class="col-2 tableTitle"scope="col">Company Name</th>
                      <th class="col-2" scope="col">Type</th>
                      <th class="col-2"scope="col">Email</th>
                      <th class="col-2"scope="col">Téléphone</th>
                      <th class="col-2"scope="col">Website</th>
                      <th class="col-2" scope="col">Action</th>
                    </tr>
                  </thead>
                <tbody *ngIf="loadListCompany === true" class="bodyTable">
                  <tr   *ngFor = "let company of dataSourceCompany | paginate: { itemsPerPage: count, currentPage: p }">
                    <td class="col-2 text-center">
                        {{company.companyName}}
                    </td>
                    <td class="col-2 text-center">
                        {{company.type}}
                    </td>
                    <td class=" col-2 text-center">
                        {{company.email}}
                    </td>
                    <td class="col-2 text-center">
                        {{company.phone}}
                    </td>
                    <td class="col-2 text-center">
                        {{company.website}}
                    </td>
                    <td class="col-2 text-center">
                      <button  (click)="opencompanyDetailInNewWindow(company._id)" type="button" style="font-size: smaller;" class="btn btn-secondary"><span class="fa fa-search"></span></button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pagination">
                <pagination-controls (pageChange)="p = $event" previousLabel = "" nextLabel = ""></pagination-controls>
              </div>
            </div>
          </div>
        </div>
    </body>
</html>